module.exports = __webpack_public_path__ + "static/media/ad.486d25a7.svg";